import { asyncStateProxy, createSelector } from "../../lib/util/ReduxUtils";
import * as GroupUtils from "../../lib/util/GroupUtils";
import { DEMO_FLEET_ID } from "../../lib/Flags";
import { Fleet } from "../../lib/types/Fleet";
import { StoreState } from "../RootReducer";

const createDummyFleet = (id: string, name: string) => ({ id, name });

export const GLOBAL_FLEET_ID = "__global";
export const GLOBAL_FLEET_NAME = "Global";
export const GLOBAL_FLEET = createDummyFleet(
	GLOBAL_FLEET_ID,
	GLOBAL_FLEET_NAME,
);

const MARK_FOR_DELETE_FLEET = createDummyFleet(
	"mark-for-delete",
	"Mark For Delete",
);

// fleet

export const selectCurrentScopeFleet = (state: StoreState) =>
	state.Fleet.scopeFleet;

export const getAllFleets = (state: StoreState) => state.Fleet.allFleets;

export const getAllFleetsWithoutDemo = (state: StoreState) =>
	(state.Fleet.allFleets.value || []).filter(
		(fleet: Fleet) => fleet?.id !== DEMO_FLEET_ID,
	);

export const getAllFleetsWithGlobalAndDeleted = createSelector(
	[getAllFleets],
	(fleets) =>
		asyncStateProxy(fleets, (value) => [
			GLOBAL_FLEET,
			MARK_FOR_DELETE_FLEET,
			...(value || []),
		]),
);

export const getFleetById = (state: StoreState, fleetId: string) =>
	(state.Fleet.allFleets.value || []).find(
		(fleet: Fleet) => fleet.id === fleetId,
	);
// groups

export const selectCurrentScopeFleetGroups = createSelector(
	[selectCurrentScopeFleet],
	(fleet) => asyncStateProxy(fleet, (value) => value!.groups, []),
);

export const getCurrentScopeFleetGroupsFlat = createSelector(
	[selectCurrentScopeFleetGroups],
	(groups) =>
		asyncStateProxy(groups, (value) =>
			value ? GroupUtils.flattenGroups(value!) : [],
		),
);
